import dayjs from 'dayjs';
import { motion } from 'framer-motion';

import { Grid, Card, Button, CardMedia, Typography, CardContent } from '@mui/material';

import { InvoiceCardStyles } from '../../styles/styles';

const CredentailsCard = ({ name, logo, description, lastSync, isConnected, onConnectClick }) => {
    const classes = InvoiceCardStyles({ isMobileScreen: false });

    const handleConnectClick = (e) => {
        e.stopPropagation();
        if (onConnectClick) {
            onConnectClick(
                {
                    name,
                    logo,
                    description,
                },
                e,
            );
        }
    };

    const formattedLastSync = lastSync
        ? dayjs(lastSync).format('YYYY-MM-DD [at] hh:mm A')
        : 'Never';

    return (
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
            <Card sx={classes.card} elevation={0}>
                <CardMedia component="img" image={logo} title={name} sx={classes.logo} />
                <CardContent sx={classes.cardContent}>
                    <Typography variant="h6">{name}</Typography>

                    <Grid container spacing={2} marginTop="10px">
                        <Grid item xs={4}>
                            <Typography color="text.secondary" fontWeight={600} fontSize="12px">
                                Portal
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography fontSize="12px">{description}</Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography color="text.secondary" fontWeight={600} fontSize="12px">
                                Account
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography
                                color={isConnected ? 'success.main' : 'error.main'}
                                fontWeight={500}
                                fontSize="12px"
                            >
                                {isConnected ? 'API Key Connected' : 'None'}
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography color="text.secondary" fontWeight={600} fontSize="12px">
                                Last Run:
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography fontSize="12px" color="text.secondary">
                                {formattedLastSync}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Button
                        variant="outlined"
                        size="small"
                        sx={classes.connectButton}
                        onClick={handleConnectClick}
                    >
                        {isConnected ? 'Update' : 'Connect'}
                    </Button>
                </CardContent>
            </Card>
        </motion.div>
    );
};

export default CredentailsCard;
